/**
 * Glassify Unified Guide Popup
 * =============================
 * - Åbner på den rigtige tab baseret på data-gfy-tab attribut på trigger-knappen
 * - Klik på "Vælg X" knap i guiden vælger den option på produktsiden og lukker popup
 * - Tab-navigation med smooth animation
 */

(function () {
  'use strict';

  const POPUP_ID = 'gfy-unified-guide';

  // Map: data-pop-up-class → tab navn
  const CLASS_TO_TAB = {
    'glass-purpose-popup':     'brilletype',
    'glass-thickness-popup':   'glastykkelse',
    'glass-coating-popup':     'coating',
    'glass-extras-popup':      'ekstravalg',
    'type-of-sunglasses-popup': 'ekstravalg',
    'glass-send-presc-popup':  'styrker',
    'glass-quality-popup':     'flerstyrke',
  };

  // Legacy popup classes to suppress when our unified guide takes over
  const SUPPRESSED_CLASSES = Object.keys(CLASS_TO_TAB);

  // Map: select-id → radio input id på produktsiden
  const SELECT_MAP = {
    // Brilletype
    'glass-purpose-one':   'glass-purpose-one',
    'glass-purpose-two':   'glass-purpose-two',
    'glass-purpose-three': 'glass-purpose-three',
    // Glastykkelse
    'glass-thickness-one':   'glass-thickness-one',
    'glass-thickness-two':   'glass-thickness-two',
    'glass-thickness-three': 'glass-thickness-three',
    'glass-thickness-four':  'glass-thickness-four',
    // Coating
    'glass-coating-one':   'glass-coating-one',
    'glass-coating-two':   'glass-coating-two',
    'glass-coating-three': 'glass-coating-three',
    'glass-coating-four':  'glass-coating-four',
    // Styrker
    'send_glasses_data_later':             'send_glasses_data_later',
    'send_glasses_data_enter_manually':    'send_glasses_data_enter_manually',
    'send_glasses_data_upload_photo':      'send_glasses_data_upload_photo',
    'send_glasses_data_copy_prescription': 'send_glasses_data_copy_prescription',
    // Flerstyrke kvalitet
    'multifocal-quality-basis':   'progressive-lenses-one',
    'multifocal-quality-premium': 'progressive-lenses-two',
    'multifocal-quality-elite':   'progressive-lenses-three',
  };

  document.addEventListener('DOMContentLoaded', function () {
    const popup    = document.getElementById(POPUP_ID);
    const backdrop = document.getElementById('gfy-guide-backdrop');
    const closeBtn = document.getElementById('gfy-guide-close');

    if (!popup) return;

    const tabs = [...popup.querySelectorAll('.gfy-tab')];
    const panels = [...popup.querySelectorAll('.gfy-tab-panel')];
    const body = popup.querySelector('.gfy-guide-body');
    const lensActions = popup.querySelector('[data-gfy-lens-actions]');
    const lensGuide = popup.querySelector('[data-gfy-lens-guide]');
    let previousFocus = null;
    let previousOverflow = '';
    let closeTimer;
    const cancelPendingClose = () => { clearTimeout(closeTimer); closeTimer = undefined; };

    // The shared modal owns opening, closing, focus and page scrolling.
    function openGuide(tabName, scope) {
      cancelPendingClose();
      if (popup.hasAttribute('hidden')) {
        previousFocus = document.activeElement;
        previousOverflow = document.body.style.overflow;
      }
      popup.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      switchTab(tabName || 'brilletype', scope);
      closeBtn?.focus();
    }

    function closeGuide() {
      cancelPendingClose();
      if (popup.hasAttribute('hidden')) return;
      popup.setAttribute('hidden', '');
      document.body.style.overflow = previousOverflow;
      popup.dispatchEvent(new CustomEvent('gfy:close'));
      previousFocus?.focus();
    }
    popup.addEventListener('gfy:close-request', closeGuide);

    // ---- Switch tab ----
    function switchTab(tabName, scope) {
      cancelPendingClose();
      // Update tab buttons
      tabs.forEach(function (btn) {
        const isActive = btn.dataset.tab === tabName;
        btn.classList.toggle('active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) btn.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });

      // Update panels
      panels.forEach(function (panel) {
        panel.classList.toggle('active', panel.dataset.panel === tabName);
      });
      body.scrollTop = 0;
      if (lensActions) lensActions.hidden = tabName !== 'ekstravalg' || !lensGuide?.dataset.ready;
      popup.dispatchEvent(new CustomEvent('gfy:tab-change', { detail: { tab: tabName, scope: scope || 'extras' } }));
    }

    // ---- Select product option ----
    function selectProductOption(selectId) {
      const radioId = SELECT_MAP[selectId];
      if (!radioId) return;

      const radio = document.getElementById(radioId);
      if (!radio || radio.disabled) return;

      // Click the associated label (triggers Shopify's variant selection)
      const label = document.querySelector('label[for="' + radioId + '"]');
      if (label) {
        label.click();
      } else {
        // Fallback: directly check the radio and dispatch change event
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        radio.dispatchEvent(new Event('input', { bubbles: true }));
      }

      // Visual feedback: briefly highlight the selected card
      popup.querySelectorAll('.gfy-card').forEach(function (card) {
        card.classList.remove('gfy-selected');
      });
      const selectedCard = popup.querySelector('.gfy-card[data-select-id="' + selectId + '"]');
      if (selectedCard) {
        selectedCard.classList.add('gfy-selected');
      }

      // Close after short delay so user sees the selection
      cancelPendingClose();
      closeTimer = setTimeout(closeGuide, 350);
    }

    // ---- Intercept existing pop-up-button clicks ----
    // These are the existing "Guide" spans on the product page with data-pop-up-class
    document.querySelectorAll('.pop-up-button, [data-gf-guide]').forEach(function (btn) {
      const popupClass = btn.getAttribute('data-pop-up-class');
      const scope = btn.dataset.gfGuide || (popupClass === 'type-of-sunglasses-popup' ? 'sun' : 'extras');
      const tabName = btn.dataset.gfGuide ? 'ekstravalg' : btn.getAttribute('data-gfy-tab') || CLASS_TO_TAB[popupClass];

      if (!tabName) return; // Not one of our guide popups, leave it alone
      if (!popup.querySelector('[data-tab="' + tabName + '"]')) return; // Tab is not available for this template

      // Override the click to open our unified guide instead
      btn.addEventListener('click', function (e) {
        e.stopImmediatePropagation(); // Prevent the old JS from firing
        openGuide(tabName, scope);
      }, true); // Use capture phase to fire before old handler
    });

    // ---- Tab button clicks ----
    popup.querySelectorAll('.gfy-tab').forEach(function (btn) {
      btn.addEventListener('click', function () {
        switchTab(btn.dataset.tab);
      });
    });

    // ---- Select buttons inside cards ----
    popup.querySelectorAll('.gfy-card-select-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        selectProductOption(btn.dataset.selectId);
      });
    });

    // ---- Card click (anywhere on card) ----
    popup.querySelectorAll('.gfy-card').forEach(function (card) {
      card.addEventListener('click', function () {
        selectProductOption(card.dataset.selectId);
      });
    });

    // ---- Close on backdrop click ----
    if (backdrop) {
      backdrop.addEventListener('click', closeGuide);
    }

    // ---- Close button ----
    if (closeBtn) {
      closeBtn.addEventListener('click', closeGuide);
    }

    // ---- Close on Escape ----
    document.addEventListener('keydown', function (e) {
      if (popup.hasAttribute('hidden')) return;
      if (e.key === 'Escape') {
        closeGuide();
      } else if (e.key === 'Tab') {
        const focusable = [...popup.querySelectorAll('button:not(:disabled), a[href], input:not(:disabled), [tabindex="0"]')].filter(el => el.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && (document.activeElement === first || !popup.contains(document.activeElement))) {
          e.preventDefault(); last?.focus();
        } else if (!e.shiftKey && (document.activeElement === last || !popup.contains(document.activeElement))) {
          e.preventDefault(); first?.focus();
        }
      }
    });

    // ---- Also hide the old popup if it's shown ----
    // (In case some other JS opens it, we hide it when our guide opens)
    const oldPopup = document.querySelector('.product-template-pop-up');
    if (oldPopup) {
      const observer = new MutationObserver(function () {
        const shouldSuppress = SUPPRESSED_CLASSES.some(function (cls) {
          return oldPopup.classList.contains(cls);
        });

        if (shouldSuppress) {
          // Old popup is trying to show one of our unified guides - close it
          SUPPRESSED_CLASSES.forEach(function (cls) {
            oldPopup.classList.remove(cls);
          });
          oldPopup.classList.remove('active');
          document.querySelector('.product-template-site-overlay')?.classList.remove('active');
          document.body.classList.remove('active-overlay');
        }
      });
      observer.observe(oldPopup, { attributes: true, attributeFilter: ['class'] });
    }
  });
})();
